import { ref, reactive } from 'vue'

export interface SnackbarAction {
  label: string
  onClick: () => void
  color?: string
}

// Global snackbar state - shared across all components
const snackbarState = reactive<{
  show: boolean
  message: string
  color: string
  timeout: number
  action?: SnackbarAction
}>({
  show: false,
  message: '',
  color: 'success',
  timeout: 3000,
  action: undefined,
})

export function useSnackbar() {
  const showSuccess = (message: string, timeout = 3000, action?: SnackbarAction) => {
    snackbarState.show = true
    snackbarState.message = message
    snackbarState.color = 'success'
    snackbarState.timeout = timeout
    snackbarState.action = action
  }

  const showError = (message: string, timeout = 5000, action?: SnackbarAction) => {
    snackbarState.show = true
    snackbarState.message = message
    snackbarState.color = 'error'
    snackbarState.timeout = timeout
    snackbarState.action = action
  }

  const showInfo = (message: string, timeout = 3000, action?: SnackbarAction) => {
    snackbarState.show = true
    snackbarState.message = message
    snackbarState.color = 'info'
    snackbarState.timeout = timeout
    snackbarState.action = action
  }

  const showWarning = (message: string, timeout = 4000, action?: SnackbarAction) => {
    snackbarState.show = true
    snackbarState.message = message
    snackbarState.color = 'warning'
    snackbarState.timeout = timeout
    snackbarState.action = action
  }

  const hide = () => {
    snackbarState.show = false
    snackbarState.action = undefined
  }

  return {
    snackbar: snackbarState,
    showSuccess,
    showError,
    showInfo,
    showWarning,
    hide,
  }
}